import axios from 'axios';
import config from 'config';

export const client = axios.create({
  baseURL: config.API_SERVER,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});
